import { Card, Form, Radio } from "antd";
import React, { useEffect } from "react";
import { ToothSample } from "../../models";
interface PropsType {
  editRecord: ToothSample;
}
export const BItem: React.FC<PropsType> = ({ editRecord }) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (editRecord.key !== -1) {
      form.setFieldsValue({ ...editRecord });
    } else {
      form.setFieldsValue({ b1: "否", b2: "否", b3: "否", b4: "否" });
    }
  }, [editRecord, form]);
  const onItemChange = (e: any) => {
    editRecord.b1 = form.getFieldValue("b1");
    editRecord.b2 = form.getFieldValue("b2");
    editRecord.b3 = form.getFieldValue("b3");
    editRecord.b4 = form.getFieldValue("b4");
  };
  return (
    <Card title="保护性因素" style={{ background: "#ececec", margin: "10px" }}>
      <Form
        layout="horizontal"
        labelCol={{ span: 16 }}
        wrapperCol={{ span: 8 }}
        form={form}
      >
        <Form.Item name="b1" label="看护者每天为儿童刷牙?">
          <Radio.Group onChange={onItemChange}>
            <Radio value={"是"}>是</Radio>
            <Radio value={"否"}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="b2" label="每天使用含氟牙膏刷牙?">
          <Radio.Group onChange={onItemChange}>
            <Radio value={"是"}>是</Radio>
            <Radio value={"否"}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="b3" label="过去12个月内接受过专业涂氟?">
          <Radio.Group onChange={onItemChange}>
            <Radio value={"是"}>是</Radio>
            <Radio value={"否"}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="b4" label="定期口腔检查(至少每半年一次)?">
          <Radio.Group onChange={onItemChange}>
            <Radio value={"是"}>是</Radio>
            <Radio value={"否"}>否</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Card>
  );
};
